<template>
    <div class="sidebar__wrap sidebar__wrap--teacher">

        <sidebar class="sidebar--teacher"
            :class=" mini ? 'sidebar--mini' : 'sidebar--expanded'"
            :user="user"
            collectionPrefix="klas"
            :collectionName="this.group.name"
            :collectionLink="{ name: 'students.overview' }"
            :backLink="{ name: 'groups' }"
            backLinkTitle="Klassen"
            :isCollectionActive="$route.name === 'students.overview'"
            @viewCollectionInfo="openSettings"
            >
            <div class="sidebar__touch-block" v-if="mini" @touchstart.capture="prevent"></div>

            <component :is="contentComponent" :group="group" :groupTerm="groupTerm" :isDemo="isDemo" ></component>

        </sidebar>

        <sidebar-workspace v-if="student != null" :user="student" :group="group" :loading="loadingUserProgress" :hideUnfinished="true" :isInspecting="true"></sidebar-workspace>

    </div>

</template>


<script>

import Sidebar from 'js/admin/components/sidebar/Sidebar.vue'
import SidebarWorkspace from 'js/components/sidebar/SidebarWorkspace.vue'
import SidebarContentStudents from 'js/components/sidebar/SidebarContentStudents.vue'
import SidebarContentTerms from 'js/components/sidebar/SidebarContentTerms.vue'
import { username } from 'js/helpers/transformers'
import { isAdmin } from 'js/api/auth'
import { getCurrentGroupPeriodForGroup } from 'js/vuex/getters'

export default {
    components: { Sidebar, SidebarWorkspace, SidebarContentStudents, SidebarContentTerms },
    props: {
        user: {
            type: Object,
        },
        group: {},
        groupTerm: {},
        loadingUserProgress: {
            type: Boolean,
        },
        isDemo: {
            type: Boolean,
        },
    },

    vuex: {
        getters: {
            getCurrentGroupPeriodForGroup,
        },
        actions: {
            showGroupSettings: ({dispatch}, group) => {
                dispatch('SHOW_MODAL', 'GroupSettings', { group: group })
            }
        }

    },

    computed: {
        student: function() {
            return this.$store.state.users.storage[this.$route.params.studentId]
        },
        mini: function() {
            return this.student != null
        },
        contentComponent: function() {
            return this.$route.params.studentId != null ? 'SidebarContentStudents' : 'SidebarContentTerms'
        },

        groupPeriod: function() {
            return this.getCurrentGroupPeriodForGroup(this.group.id)
        },

    },
    methods: {
        username,
        prevent: function(event) {
            // prevents triggering links when touching the mini sidebar to open it
            event.stopPropagation()
            event.preventDefault()
        },
        openSettings: function() {
            if ( isAdmin(this.user) ) {
                this.showGroupSettings(this.group)
            }
        }
    },

}
</script>



<style lang="scss">

    @import 'global';

    .sidebar {

        .mini-visible {
            display: none !important;
        }

        // TODO: mini:not(:hover)
        &.sidebar--mini {
            width: $sidebar-mini-width;
            z-index: $z-index-sidebar+1;
            @include gradient(darken($color-primary, 10%), darken($color-secondary, 10%));
            border-right: 1px solid transparentize($color-white, 0.6);

            transition: width 0.2s ease-out;
            overflow-x: hidden;

            .sidebar__name {
                float: none !important;
                display: block;
                text-align: center;
                &:after {
                    content: none;
                }
            }

            .sidebar__back {
                display: none !important;
            }

            .mini-hidden {
                display: none !important;
            }

            .mini-visible {
                display: inline-block !important;
            }

            // Overlay which disable touch actions
            .sidebar__touch-block {
                display: none;
                .isTouchEnabled & {
                    display: block;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    pointer-events: all;
                    z-index: 999;
                }
            }

            &:hover {
                width: $sidebar-max-width;
                box-shadow: 5px 0 100px rgba(0,0,0,0.3);
                border-right: none;
                @include gradient($color-primary, $color-secondary);

                // remove overlay to enable touch actions
                .sidebar__touch-block {
                    display: none;
                }

                // prevents reflowing content during transition
                .sidebar__content, .sidebar__tag {
                    width: $sidebar-max-width;
                }

                .mini-hidden {
                    display: inline-block !important;
                }

                .mini-visible {
                    display: none !important;
                }

                .sidebar__back {
                    display: inline-block !important;
                }

                .sidebar__name {
                    float: right !important;
                    &:after {
                        content: '' !important;
                    }
                }
            }

        }

        &__wrap {

            &--teacher {

                .sidebar--student {
                    @include gradient(lighten($color-primary, 7%), lighten($color-secondary, 5%));
                    left: $sidebar-mini-width;
                }

            }
        }

    }


</style>



// WEBPACK FOOTER //
// SidebarTeacher.vue?270f76ae